import { createFileRoute } from "@tanstack/react-router";

import { LegalPage } from "@/web/routes/-legal/LegalPage";
import faqHtml from "@/web/routes/-legal/faq.md?html";
import { appUrl } from "@/web/lib/siteUrls";

const DESCRIPTION =
  "How With Studios, Inc. collects, uses, and protects your personal information.";

export const Route = createFileRoute("/faq")({
  ssr: true,
  head: () => ({
    meta: [
      { title: "FAQ — WITH.CO" },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: "FAQ — WITH.CO" },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: appUrl("/faq") },
      { property: "og:type", content: "website" },
    ],
  }),
  // Each Q/A pair renders as one <p> with the question and answer split by a
  // <br> (the two trailing spaces in faq.md). `each-line` re-applies the
  // negative text-indent after that forced break, so both the "Q:" and "A:"
  // labels hang at the margin while wrapped lines align at the 1.5em rule.
  // The <br> is forced to `display: block` with empty content so a top margin
  // can open vertical space between the question and its answer.
  component: () => (
    <LegalPage
      title="FAQ"
      html={faqHtml}
      contentClassName="[&_p]:pl-[1.2em] [&_p]:[text-indent:-1.2em_each-line]"
    />
  ),
});
